// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3K5XU","container":"Footer_container__2OjNi","logo":"Footer_logo__3je31","copyright":"Footer_copyright__2eIaL"};